import { render, staticRenderFns } from "./JsGroup.vue?vue&type=template&id=49594200&scoped=true&"
import script from "./JsGroup.vue?vue&type=script&lang=js&"
export * from "./JsGroup.vue?vue&type=script&lang=js&"
import style0 from "./JsGroup.vue?vue&type=style&index=0&id=49594200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49594200",
  null
  
)

export default component.exports